<script setup>
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'
import {useViewStore} from '@/stores/view'

// Component Imports
import Button from '@/common/Button.vue'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Pinia Store
const userStore = useUserStore()

// Computed Properties
const tableName = computed(() => viewStore.tableName)
const selectedIds = computed(() => viewStore.selectedIds || [])
const viewMode = computed(() => viewStore.viewMode)

const hasEditAccess = computed(() => {
    return tableName.value ? userStore.access(tableName.value, 'edit') : false
})

// Methods
const onClick = () => {
    window.location = '/#/' + tableName.value + '/' + selectedIds.value[0]
}
</script>

<template>
    <Button v-if="hasEditAccess && viewMode === 'thumbnail'" :class="{ disabled: selectedIds.length !== 1 }"
            class="rounded-0" title="Edit" @click="onClick">
        <i class="bi-pencil-square"/>
    </Button>
</template>